/*
 * Action Types
 */
export enum CardReceivablesTypes {
  GET_CARD_PENDENCIES_REQUEST = '@cardReceivables/GET_CARD_PENDENCIES_REQUEST',
  GET_CARD_PENDENCIES_SUCCESS = '@cardReceivables/GET_CARD_PENDENCIES_SUCCESS',
  GET_CARD_PENDENCIES_FAILURE = '@cardReceivables/GET_CARD_PENDENCIES_FAILURE',

  GENERATE_CARD_PAYMENT_REQUEST = '@cardReceivables/GENERATE_CARD_PAYMENT_REQUEST',
  GENERATE_CARD_PAYMENT_SUCCESS = '@cardReceivables/GENERATE_CARD_PAYMENT_SUCCESS',
  GENERATE_CARD_PAYMENT_FAILURE = '@cardReceivables/GENERATE_CARD_PAYMENT_FAILURE',

  GET_CARD_HISTORY_REQUEST = '@cardReceivables/GET_CARD_HISTORY_REQUEST',
  GET_CARD_HISTORY_SUCCESS = '@cardReceivables/GET_CARD_HISTORY_SUCCESS',
  GET_CARD_HISTORY_FAILURE = '@cardReceivables/GET_CARD_HISTORY_FAILURE',

  REFRESH_CARD_PAYMENT_REQUEST = '@cardReceivables/REFRESH_CARD_PAYMENT_REQUEST',
  REFRESH_CARD_PAYMENT_SUCCESS = '@cardReceivables/REFRESH_CARD_PAYMENT_SUCCESS',
  REFRESH_CARD_PAYMENT_FAILURE = '@cardReceivables/REFRESH_CARD_PAYMENT_FAILURE',

  RELEASE_CARD_PAYMENT_REQUEST = '@cardReceivables/RELEASE_CARD_PAYMENT_REQUEST',
  RELEASE_CARD_PAYMENT_SUCCESS = '@cardReceivables/RELEASE_CARD_PAYMENT_SUCCESS',
  RELEASE_CARD_PAYMENT_FAILURE = '@cardReceivables/RELEASE_CARD_PAYMENT_FAILURE',

  RESET_CARD_RECEIVABLES = '@cardReceivables/RESET_CARD_RECEIVABLES',
}

/*
 * Data Types
 */
export interface CardTransactionInterface {
  id: string;
  value: number;
  date: number;
}

export interface CardPixPaymentInterface {
  id: string;
  qrcode: string;
  expires: number;
  companyName: string;
  value: number;
}

export interface CardPaymentHistoryInterface {
  paymentId: string;
  value: number;
  date: number;
  status: 'paid' | 'pending';
}

export interface CardReceivablesState {
  readonly cardNumber: string;
  readonly transactionsList: CardTransactionInterface[] | null;
  readonly pixPayment: CardPixPaymentInterface | null;
  readonly historyList: CardPaymentHistoryInterface[] | null;
  readonly loading: boolean;
  readonly generatingPayment: boolean;
  readonly historyLoading: boolean;
  readonly error: boolean;
}
